// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"a3751f24","453":"a108676b"}[chunkId] + ".chunk.js";
};